import {
  PUSH_NOTIFICATION,
  DELETE_NOTIFICATION,
  CLOSE_COOKIES_NOTIFICATION,
  SHOW_MODAL,
  HIDE_MODAL
} from ":mutations";

const state = {
  notifications: [],
  cookiesNotificationShown: true,
  modal: {
    component: null,
    props: {}
  }
};

const mutations = {
  [PUSH_NOTIFICATION](state, { component, props }) {
    state.notifications.unshift({
      id: Symbol(),
      component,
      props: props || {}
    });
  },

  [DELETE_NOTIFICATION](state, { id }) {
    state.notifications.splice(
      state.notifications.findIndex(n => n.id === id),
      1
    );
  },

  [CLOSE_COOKIES_NOTIFICATION](state) {
    state.cookiesNotificationShown = false;
  },

  [SHOW_MODAL](state, { component, props = {} }) {
    state.modal = { component, props };
  },

  [HIDE_MODAL]({ modal }) {
    modal.component = null;
    modal.props = {};
  }
};

const actions = {};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
